<section class="rv" id="client-reviews" #root aria-labelledby="rv-title">
  <div class="container">
    <!-- the whole section sits inside one soft gradient panel -->
    <div class="rv__panel">
      <div class="rv__panel-bg" aria-hidden="true">
        <span class="rv__blob rv__blob--pink"></span>
        <span class="rv__blob rv__blob--violet"></span>
        <span class="rv__spark rv__spark--1"></span>
        <span class="rv__spark rv__spark--2"></span>
        <span class="rv__spark rv__spark--3"></span>
        <span class="rv__spark rv__spark--4"></span>
      </div>

      <header class="rv__head" #head>
        <span class="rv__badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 20s-7.5-4.6-7.5-9.5A4.2 4.2 0 0 1 12 8a4.2 4.2 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z" />
          </svg>
          WHAT CLIENTS SAY
        </span>

        <h2 class="rv__title" id="rv-title">
          Review From <span class="rv__title-grad">Clients</span>
        </h2>

        <span class="rv__divider" aria-hidden="true"><i></i><em></em><i></i></span>
      </header>

      <!-- ============================================================
           SLIDER — three on stage, centre active
           ============================================================ -->
      <div class="rv__stage" #stage>
        <button
          type="button"
          class="rv__nav rv__nav--prev"
          (click)="go(-1)"
          aria-label="Previous review"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15 6l-6 6 6 6" />
          </svg>
        </button>

        <div class="rv__track">
          <article
            class="rv__card"
            *ngFor="let r of reviews; let i = index; trackBy: trackReview"
            [class.is-active]="offset(i) === 0"
            [class.is-off]="!isOnStage(i)"
            [style.--o]="offset(i)"
            [style.zIndex]="10 - (offset(i) < 0 ? -offset(i) : offset(i))"
            [attr.aria-hidden]="isOnStage(i) ? null : 'true'"
          >
            <span class="rv__quote" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.6 5.5C6.5 6.9 4.6 9.6 4.6 12.9c0 3.2 1.9 5.4 4.4 5.4 2.1 0 3.7-1.5 3.7-3.5 0-1.9-1.4-3.3-3.2-3.3-.4 0-.8.06-1 .12.35-1.6 1.9-3.2 3.8-4zM19.4 5.5c-3.1 1.4-5 4.1-5 7.4 0 3.2 1.9 5.4 4.4 5.4 2.1 0 3.7-1.5 3.7-3.5 0-1.9-1.4-3.3-3.2-3.3-.4 0-.8.06-1 .12.35-1.6 1.9-3.2 3.8-4z" />
              </svg>
            </span>

            <p class="rv__text">{{ r.description }}</p>

            <span class="rv__foot">
              <span class="rv__who">
                <span class="rv__avatar" aria-hidden="true">{{ initials(r.title) }}</span>
                <span class="rv__meta">
                  <b>{{ r.title.trim() }}</b>
                  <u>{{ r.country }}</u>
                </span>
              </span>

              <span class="rv__stars" [attr.aria-label]="'Rated 5 out of 5'">
                <svg *ngFor="let s of [1,2,3,4,5]" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="m12 3.4 2.6 5.4 5.9.8-4.3 4.2 1 5.9L12 17l-5.2 2.7 1-5.9-4.3-4.2 5.9-.8z" />
                </svg>
              </span>
            </span>

            <span class="rv__edge" aria-hidden="true"></span>
          </article>
        </div>

        <button
          type="button"
          class="rv__nav rv__nav--next"
          (click)="go(1)"
          aria-label="Next review"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 6 6 6-6 6" />
          </svg>
        </button>
      </div>

      <div class="rv__dots" role="tablist" aria-label="Choose a review">
        <button
          type="button"
          role="tab"
          *ngFor="let r of reviews; let i = index; trackBy: trackReview"
          class="rv__dot"
          [class.is-on]="offset(i) === 0"
          [attr.aria-selected]="offset(i) === 0"
          [attr.aria-label]="'Review by ' + r.title.trim()"
          (click)="select(i)"
        ></button>
      </div>
    </div>
  </div>
</section>
